module.exports = __webpack_public_path__ + "icon-aws.3C__l3Im.svg";